<template>
    <div>
        <v-navigation-drawer
                fixed
                app
                :clipped="$vuetify.breakpoint.mdAndUp"
                :fixed="true"
                :value="drawer"
                width="250"
                @input="$emit('toggleDrawer', $event)"
        >
            <v-list dense>
                <v-container fluid>
                    <department-subject-switcher
                            :type="navigationSelectorType"
                            :is-open="isDepartmentSubjectSwitcherOpened"
                            :is-show-button="isDepSubjNavigation()"
                            @changeDialogState="isDepartmentSubjectSwitcherOpened = $event"
                            :route-to="switcherDialogRoute"
                            route-back="ratingHome"
                    />
                </v-container>
                
                <v-subheader class="mt-1 grey--name name--darken-1">Рейтинг НПП поточного року</v-subheader>
                <navigation-list-template :items="dictionaryItems" @selectValue="setTopNavigationItem($event)"/>
                <v-divider></v-divider>
                <v-subheader class="mt-1 grey--name name--darken-1">Архів рейтингу НПП</v-subheader>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import NavigationListTemplate from "../../common/NavigationListTemplate";
    import DepartmentSubjectSwitcher from "../../common/DepartmentSubjectSwitcher";
    import {mapMutations} from "vuex";
    import {navigationSelectorTypesEnum} from "../../../constants/navigationSelectorTypesEnum";

    export default {
        props: {
            drawer: {
                type: Boolean,
            }
        },
        components: {
            NavigationListTemplate,
            DepartmentSubjectSwitcher
        },
        mounted() {
            this.dictionaryItems = this.remapItems(this.dictionaryItemsRaw);

            this.dialogNavigationDepartmentSubject(this.$route.name);
        },
        watch: {
            $route (to, from){
                if (to.name !== from.name) {
                    this.dialogNavigationDepartmentSubject(to.name);
                }
            }
        },
        methods: {
            ...mapMutations(['setTopNavigationItem']),
            dialogNavigationDepartmentSubject(routeName) {
                if (!this.isDepSubjNavigation() && this.$route.name !== 'ratingHome') {
                    this.navigationSelectorType = navigationSelectorTypesEnum.moderator;

                    if (this.$route.params.department === undefined) {
                        this.isDepartmentSubjectSwitcherOpened = true;
                    }

                    this.switcherDialogRoute = routeName;
                }

                if (this.$route.name === 'currentRating') {
                    this.navigationSelectorType = navigationSelectorTypesEnum.moderatorReworks;
                }
            },
            remapItems(items) {
                let itemsRemapped = items.slice(0);

                return itemsRemapped.map(item => {
                    if (item.children !== undefined) {
                        item.children = item.children.map(ch => {
                            if (ch.route && ch.route.name && this.$route.name === ch.route.name) {
                                ch.model = true;
                                this.setTopNavigationItem(ch);
                            }
                            return ch;
                        });

                        let someActiveChildren = item.children.find(ch => ch.model);

                        if (someActiveChildren !== undefined) {
                            item.model = true;
                        }

                        return item;
                    }

                    if (item.route && item.route.name && this.$route.name === item.route.name) {
                        this.setTopNavigationItem(item);
                    }

                    return item;
                })
            },
            isDepSubjNavigation() {
                if (this.$route.name === 'currentRating') {
                    return this.$route.params.department !== undefined;
                }

                return (this.$route.params.department !== undefined &&
                    this.$route.params.subject !== undefined);
            }
        },
        data: () => ({
            switcherDialogRoute: "",
            isDepartmentSubjectSwitcherOpened: false, 
            dictionaryItems: [],
            dictionaryItemsRaw: [
                {
                    icon: 'assessment',
                    name: 'Рейтинг НПП',
                    route: {
                        name: 'currentRating'
                    }
                },
            ],
            navigationSelectorType: navigationSelectorTypesEnum.moderator,
        })
    }
</script>